module.exports = __webpack_public_path__ + "media/images/arrow_down-b79d7c4c7f2a73ecf7816b64d5a1d332.svg";